import { render, staticRenderFns } from "./WithSearch.vue?vue&type=template&id=aa4d9646&"
import script from "./WithSearch.vue?vue&type=script&lang=js&"
export * from "./WithSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports